exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:769px){.masonry-container[data-v-97aaf116]{column-count:4;column-gap:1rem}}@media (max-width:768px){.masonry-container[data-v-97aaf116]{column-count:2;column-gap:1rem}}.scoped-contain-image[data-v-97aaf116]{max-width:100%;display:block}.scoped-file-icon[data-v-97aaf116]{border:1px solid #000;box-shadow:1px 2px 3px #939393;margin:1.1rem;padding:.5rem}.scoped-file-icon[data-v-97aaf116]:first-of-type{margin-top:0}.scoped-file-icon.scope-selected-file[data-v-97aaf116]{border:1px solid var(--LS-admintheme-basecolor);box-shadow:3px 6px 9px var(--LS-admintheme-basecolor)}", ""]);

// exports
